import React, { useRef } from 'react'
import { Grid2, TextField } from '@mui/material'

const ConfirmationCodeInput = ({ code, setCode, smsCodeError }) => {
  const inputRefs = useRef([])

  const handleInputChange = (e, index) => {
    const { value } = e.target
    if (value.length <= 1) {
      const newCode = [...code]
      newCode[index] = value
      setCode(newCode)

      if (value && index < 3) {
        inputRefs.current[index + 1].focus()
      }
    }
  }

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && !code[index] && index > 0) {
      inputRefs.current[index - 1].focus()
    }
  }

  const handlePaste = e => {
    e.preventDefault()
    const pasteData = e.clipboardData.getData('Text').slice(0, 4).split('')

    if (pasteData.length === 4) {
      setCode(pasteData)
      inputRefs.current[3].focus()
    }
  }

  return (
    <Grid2
      container
      sx={{
        display: 'flex',
        justifyContent: 'flex-start',
        gap: '10px',
        flexWrap: 'nowrap',
        height: 'auto',
        alignItems: 'center'
      }}
      onPaste={handlePaste}
    >
      {code?.map((value, index) => (
        <TextField
          key={index}
          fullWidth
          inputRef={el => (inputRefs.current[index] = el)}
          value={value}
          onChange={e => handleInputChange(e, index)}
          onKeyDown={e => handleKeyDown(e, index)}
          onInput={event => {
            event.target.value = event.target.value.replace(/\D/g, '')
          }}
          error={smsCodeError}
          inputProps={{
            maxLength: 1,
            style: {
              textAlign: 'center',
              fontSize: '2rem',
              height: '60px',
              borderColor: 'initial'
            }
          }}
        />
      ))}
    </Grid2>
  )
}

export default ConfirmationCodeInput
